export default class BusinessUnitTaxApiModel {
  constructor(rawModel) {
    this.BusinessUnitKey = rawModel?.BusinessUnitKey || null
    this.AvailableTax = rawModel?.AvailableTax?.map(x => new LocalizedTaxApiModel(x)) || []
  }
}

class LocalizedTaxApiModel {
  constructor(rawModel) {
    this.Key = rawModel?.Key || null
    this.BusinessUnitKey = rawModel?.BusinessUnitKey || null
    this.Percentage = rawModel?.Percentage || null
    this.Description = rawModel?.Description || null
    this.Active = rawModel?.Active || null
    this.CoutryAlpha2 = rawModel?.CoutryAlpha2 || null
  }
}
